import { render, staticRenderFns } from "./cash.vue?vue&type=template&id=36b3daeb&scoped=true&"
import script from "./cash.vue?vue&type=script&lang=js&"
export * from "./cash.vue?vue&type=script&lang=js&"
import style0 from "./cash.vue?vue&type=style&index=0&id=36b3daeb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3daeb",
  null
  
)

export default component.exports